import { render, staticRenderFns } from "./ViewBlogPost.vue?vue&type=template&id=b86e37b0"
import script from "./ViewBlogPost.vue?vue&type=script&lang=js"
export * from "./ViewBlogPost.vue?vue&type=script&lang=js"
import style0 from "./ViewBlogPost.vue?vue&type=style&index=0&id=b86e37b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports